import { createPlugin } from "../createPlugin";
import { PlayerEvent } from "../../Core/PlayerEvents";

/**
 * WebVTT subtitle plugin.
 * Additional formats: convert to WebVTT (or register a parser) before setTextTracks.
 */
export function createSubtitlesPlugin(options) {
  options = options || {};

  return createPlugin({
    name: "subtitles",
    version: "0.1.0",
    onReady: function (ctx) {
      var tracks = options.tracks || ctx.config.subtitles || [];
      var controller = ctx.tracks;
      if (!controller) {
        return;
      }

      controller.setTextTracks(tracks);
      if (ctx.shell) {
        controller.applySubtitleTheme(
          ctx.shell,
          (ctx.config.theme && ctx.config.theme.subtitles) || options.style || {}
        );
      }

      // Re-publish for UI
      ctx.bus.emit(PlayerEvent.TEXT_TRACKS_CHANGED, {
        tracks: controller.getTextTracks(),
        activeId: controller.getActiveTextTrackId(),
      });

      ctx.bus.on("ui:selectTextTrack", function (id) {
        var catalog = controller.getTextTracks();
        if (id === "on") {
          if (catalog[0]) {
            id = catalog[0].id;
          } else {
            ctx.bus.emit(PlayerEvent.ANNOUNCEMENT, {
              message:
                "Subtitles are not available for this video at this time.",
              ttlMs: 4000,
            });
            return;
          }
        }
        if (id && id !== "off" && !catalog.length) {
          ctx.bus.emit(PlayerEvent.ANNOUNCEMENT, {
            message:
              "Subtitles are not available for this video at this time.",
            ttlMs: 4000,
          });
          return;
        }
        controller.selectTextTrack(id);
        ctx.bus.emit(PlayerEvent.TEXT_TRACK_SELECTED, {
          id: controller.getActiveTextTrackId(),
        });
        ctx.bus.emit(PlayerEvent.ANNOUNCEMENT, {
          message:
            id && id !== "off" ? "Subtitles on" : "Subtitles off",
          ttlMs: 2500,
        });
      });

      ctx.bus.on("ui:toggleSubtitles", function () {
        var current = controller.getActiveTextTrackId();
        if (current) {
          ctx.bus.emit("ui:selectTextTrack", "off");
        } else {
          var list = controller.getTextTracks();
          if (list[0]) {
            ctx.bus.emit("ui:selectTextTrack", list[0].id);
          } else {
            ctx.bus.emit(PlayerEvent.ANNOUNCEMENT, {
              message:
                "Subtitles are not available for this video at this time.",
              ttlMs: 4000,
            });
          }
        }
      });
    },
  });
}

export default createSubtitlesPlugin;
